import apiGenerator from '../apiGenerator';
import Feedback, { feedbackToApiMap } from '../../models/Feedback';
import { mapModelToApi } from '../../models/modelMapper';

// Actions
const ADD_FEEDBACK_REQUEST = 'ctm/feedback/ADD_FEEDBACK';
const ADD_FEEDBACK_SUCCESS = 'ctm/feedback/ADD_FEEDBACK_SUCCESS';
const ADD_FEEDBACK_FAILURE = 'ctm/feedback/ADD_FEEDBACK_FAILURE';

// Action Creators
// eslint-disable-next-line import/prefer-default-export
export function createNewFeedback(feedback, onSuccess, onFailure) {
  const newFeedback = new Feedback(feedback);

  return (dispatch) => {
    dispatch(apiGenerator({
      endpoint: 'feedback',
      method: 'POST',
      body: mapModelToApi(newFeedback, feedbackToApiMap),
      types: [
        ADD_FEEDBACK_REQUEST,
        {
          type: ADD_FEEDBACK_SUCCESS,
          payload: '',
        },
        ADD_FEEDBACK_FAILURE,
      ],
    }))
      .then((r) => {
        if (r.error) {
          onFailure(r.payload);
        } else {
          onSuccess(r.payload);
        }
      })
      .catch(onFailure);
  };
}



// WEBPACK FOOTER //
// ./src/redux/ducks/feedback.js